import { render, staticRenderFns } from "./projectSetMenu.vue?vue&type=template&id=23acc1f5&scoped=true"
import script from "./projectSetMenu.vue?vue&type=script&lang=js"
export * from "./projectSetMenu.vue?vue&type=script&lang=js"
import style0 from "./projectSetMenu.vue?vue&type=style&index=0&id=23acc1f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acc1f5",
  null
  
)

export default component.exports